import { store } from '../store/store'

export default function ({ to, next }) {
  const { userType } = store.state.auth
  if (!to.meta.roles || to.meta.roles.includes(userType)) {
    return next()
  }
  return next({ path: '/' })
}
